import moment from 'moment';

Vue.component('appointment-results', {
    props: ['quote-id', 'appointment'],

    data () {
        return {
            working: false,

            reviews: [],

            createForm: $.extend(true, new Form({
                data: {
                    review: '',
                    rating: null,
                }
            }), {}),

            editForm: $.extend(true, new Form({
                data: {
                    review: '',
                    rating: null,
                }
            }), {}),

            deleteReviewItem: null,

            editReviewItem: null,

            editKey: null,
        }
    },

    mounted () {
        this.fetchReviews();
    },

    methods: {
        fetchReviews () {
            axios.get(`/api/reviews/?quote_id=${this.quoteId}`)
                .then((response) => {
                    this.reviews = response.data;
                });
        },

        setCreateFormRating (rating) {
            this.createForm.data.rating = rating;
        },

        setEditFormRating (rating) {
            this.editForm.data.rating = rating;
        },

        createReview () {
            Http.post(`/api/reviews/store/?quote_id=${this.quoteId}`, this.createForm)
                .then(() => {
                    this.fetchReviews();

                    this.createForm.review = '';
                    this.createForm.rating = null;
                });
        },

        updateReview () {
            Http.post(`/api/reviews/update/${this.editReviewItem.id}`, this.editForm)
                .then(() => {
                    this.fetchReviews();

                    this.editForm.review = '';
                    this.editForm.rating = null;

                    this.editForm.resetAlert();

                    this.editReviewItem = null;
                    this.editKey = null;
                });
        },

        editReview (review, editKey) {
            this.editForm.data.review = review.review;
            this.editForm.data.rating = review.rating;

            this.editReviewItem = review;

            this.editKey = editKey;
        },

        deleteReview (review) {
            this.deleteReviewItem = review;

            $('#delete-review').modal('show');
        },

        doDeleteReview () {
            axios.post(`/api/reviews/remove/${this.deleteReviewItem.id}`)
                .then((response) => {
                    this.fetchReviews();

                    this.deleteReviewItem = null;

                    $('#delete-review').modal('hide');
                });
        },

        cancelEdit () {
            this.editKey = null;
        }
    }
});
